
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';
import { Modal, Box, Typography, IconButton, Button, CircularProgress } from '@mui/material';

import { useInventoryService } from 'store/services/inventory.service';


const RefundDetailsModal = ({ open, onClose, refundData, onUnmatchSuccess }) => {
    const { unMatchRefund } = useInventoryService();
    const [isLoading, setIsLoading] = useState(false);

    const companyId = useSelector((state) => state?.company?.data?.id);

    const handleUnmatchRefund = async () => {
        if (!refundData?.transactionId) return;
        setIsLoading(true);
        try {
            await unMatchRefund({
                plaidTransactionId: refundData.transactionId,
                company_id: companyId
            });
            onUnmatchSuccess?.(refundData.transactionId);
            onClose();
        } catch (error) {
            console.error('Failed to unmatch refund:', error);
        } finally {
            setIsLoading(false);
        }
    };
    if (!refundData) return null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="refund-details-modal"
            aria-describedby="refund-details-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 1,
                    outline: 'none'
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6" component="h2">
                        Refund Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                
                <Box>
                    <Typography><strong>Date:</strong> {refundData.date ? new Date(refundData.date).toLocaleDateString() : 'N/A'}</Typography>
                    <Typography><strong>Amount:</strong> {refundData.amount || 'N/A'}</Typography>
                    <Typography><strong>Description:</strong> {refundData.description || 'N/A'}</Typography>
                    
                    <Box mt={3} pt={2} borderTop="1px solid #e0e0e0">
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleUnmatchRefund}
                            disabled={isLoading}
                            startIcon={isLoading ? <CircularProgress size={20} /> : null}
                        >
                            {isLoading ? 'Processing...' : 'Unmatch Refund'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default RefundDetailsModal;
